import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, Form, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone"
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, useBoreholeUpdateMutation, useBoreholeFindAllQuery } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import OwnerIndex from "Components/Owner/Index";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import WaterBearing from "./WaterBearing";
import Flatpickr from "react-flatpickr";


const UgBoreholeShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("google")
  const { data, error, isFetching } = useBoreholeFindAllQuery(`/${id}`);
  const [boreholeMainData, setBoreholeMainData] = useState<any>();
  const [BoreholeGeom, setBoreholeGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const [boreholeUpdate, boreholeUpdateResult] = useBoreholeUpdateMutation();

  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);

  const {
    data: costType,
    error: costTypeError,
    isFetching: isCostTypeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setBoreholeMainData(data?.data)

    const tempMineral = boreholeMainData !== null ? boreholeMainData?.is_mineral : false;
    setMineralBoolean(tempMineral)

    setBoreholeGeom(boreholeMainData?.geom)
    const tempCenter = { cusCenter: BoreholeGeom?.coordinates };
    setCustomCenter(tempCenter);

  }, [BoreholeGeom, boreholeMainData, data])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: boreholeMainData?.id,
      code: boreholeMainData?.code,
      budget_cost: boreholeMainData?.budget_cost,
      cmn_invesetment_source: boreholeMainData?.cmn_invesetment_source,
      usage_date: boreholeMainData?.usage_date,
      depth: boreholeMainData?.depth,
      diameter: boreholeMainData?.diameter,
      sea_level_m: boreholeMainData?.sea_level_m,
      borehole_design: boreholeMainData?.borehole_design,
      bored_organization: boreholeMainData?.bored_organization,
      drilling_method_brand: boreholeMainData?.drilling_method_brand,
      location: boreholeMainData?.location,

      au1_name: boreholeMainData?.au1_name,
      au2_name: boreholeMainData?.au2_name,
      au3_name: boreholeMainData?.au3_name,
      latitude: boreholeMainData?.latitude,
      longitude: boreholeMainData?.longitude,
      elevation: boreholeMainData?.elevation,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      diameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      borehole_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      bored_organization: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sea_level_m: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      drilling_method_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append('id', boreholeMainData ? boreholeMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('usage_date', values?.usage_date);
      formData.append('is_mineral', String(mineralBoolean ?? false));
      formData.append('depth', values?.depth);
      formData.append('diameter', values?.diameter);
      formData.append('budget_cost', values?.budget_cost);
      formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
      formData.append('borehole_design', values?.borehole_design);
      formData.append('bored_organization', values?.bored_organization);
      formData.append('sea_level_m', values?.sea_level_m);
      formData.append('drilling_method_brand', values?.drilling_method_brand);
      formData.append('location', values?.location);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }

      boreholeUpdate(formData);
      validation.resetForm();
      setResetFiles(true);
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Газрын доорх ус" breadcrumbItem="Цооног" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Цооног</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Бүртгэлийн дугаар  *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code &&
                                validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Далайн түвшинээс дээш метр *</Label>
                              <Input
                                name="sea_level_m"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sea_level_m || ""}
                                invalid={
                                  validation.touched.sea_level_m && validation.errors.sea_level_m
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.sea_level_m}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Ашиглалтанд оруулсан он *</Label>
                              <Input
                                name="usage_date"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.usage_date || ""}
                                invalid={
                                  validation.touched.usage_date && validation.errors.usage_date
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.usage_date && validation.errors.usage_date ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.usage_date}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label >Аймаг, нийслэл</Label>
                              <Input
                                name="au1_name"
                                disabled
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au1_name || ""}
                                invalid={
                                  validation.touched.au1_name && validation.errors.au1_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au1_name && validation.errors.au1_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au1_name}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label >Өндөршилт, Z</Label>
                              <Input
                                disabled
                                name="elevation"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.elevation || ""}
                                invalid={
                                  validation.touched.elevation && validation.errors.elevation
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.elevation && validation.errors.elevation ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.elevation}
                                </FormFeedback>
                              ) : null}
                            </div>


                          </Col>

                          <Col lg={4}>

                            <div className="mb-3">
                              <Label className="text-danger">Рашаан эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setMineralBoolean(!mineralBoolean);
                                }}
                                checked={mineralBoolean}
                              />
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Төсөв өртөг *</Label>
                              <Input
                                name="budget_cost"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.budget_cost || ""}
                                invalid={
                                  validation.touched.budget_cost && validation.errors.budget_cost
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.budget_cost && validation.errors.budget_cost ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.budget_cost}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Цооногийн гүн, м *</Label>
                              <Input
                                name="depth"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.depth || ""}
                                invalid={
                                  validation.touched.depth &&
                                    validation.errors.depth
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.depth &&
                                validation.errors.depth ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.depth}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Мэргэжлийн байгууллага *</Label>
                              <Input
                                name="bored_organization"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.bored_organization || ""}
                                invalid={
                                  validation.touched.bored_organization && validation.errors.bored_organization
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.bored_organization && validation.errors.bored_organization ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.bored_organization}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Сум, дүүрэг</Label>
                              <Input
                                disabled
                                name="au2_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au2_name || ""}
                                invalid={
                                  validation.touched.au2_name && validation.errors.au2_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au2_name && validation.errors.au2_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au2_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Баг/Хороо</Label>
                              <Input
                                disabled
                                name="au3_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au3_name || ""}
                                invalid={
                                  validation.touched.au3_name && validation.errors.au3_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au3_name && validation.errors.au3_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au3_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Өрөмдлөгйин арга ба суурь машины марк *</Label>
                              <Input
                                name="drilling_method_brand"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.drilling_method_brand || ""}
                                invalid={
                                  validation.touched.drilling_method_brand && validation.errors.drilling_method_brand
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.drilling_method_brand && validation.errors.drilling_method_brand ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.drilling_method_brand}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хоолойн хийц *</Label>
                              <Input
                                name="borehole_design"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.borehole_design || ""}
                                invalid={
                                  validation.touched.borehole_design && validation.errors.borehole_design
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.borehole_design && validation.errors.borehole_design ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.borehole_design}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Төсвийн үүсвэр*</Label>
                              <Input
                                name="cmn_invesetment_source"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_invesetment_source || ""}
                                invalid={
                                  validation.touched.cmn_invesetment_source &&
                                    validation.errors.cmn_invesetment_source
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {costType?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_invesetment_source &&
                                validation.errors.cmn_invesetment_source ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_invesetment_source}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Цооногийн амсрын диаметр, мм*</Label>
                              <Input
                                name="diameter"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.diameter || ""}
                                invalid={
                                  validation.touched.diameter &&
                                    validation.errors.diameter
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.diameter &&
                                validation.errors.diameter ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.diameter}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label >Солбицол Х</Label>
                              <Input
                                disabled
                                name="latitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.latitude || ""}
                                invalid={
                                  validation.touched.latitude && validation.errors.latitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.latitude && validation.errors.latitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.latitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол У</Label>
                              <Input
                                disabled
                                name="longitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.longitude || ""}
                                invalid={
                                  validation.touched.longitude && validation.errors.longitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.longitude && validation.errors.longitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.longitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'point'} />
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className='mapTypeSelection'>
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                            </div>
                            <MainMap baseMap={baseMap} results={BoreholeGeom} customCenter={customCenter} zoomChange={15} type={'point'} />
                          </Col>

                        </Row>

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <WaterBearing id={id} />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'borehole'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'borehole'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'borehole'} />
                    </TabPane>

                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UgBoreholeShow;